<template>
  <div class="form-item" v-show="visible">
    <el-form>
      <el-form-item :label="localized(`label`)">
        <el-tooltip
          class="item"
          effect="dark"
          placement="left"
          v-if="fatherContent.displayReference && fatherContent.displayReference.description"
        >
          <div slot="content">{{fatherContent.displayReference.description}}</div>
          <img class="form-tooltip" :src="require('@/assets/question.png')" />
        </el-tooltip>
        <el-input type="textarea" v-model="itemdata" :rows="3" disabled class="rt-input"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import callApp from "@/services/sdk";
import utils from "@/utils";
import language from "@/lang";
export default {
  uuid: "00000000-0000-0000-0000-000000100002",
  components: {},
  props: ["jsonContent", "fatherContent", "datamodel", "disabled", "host", "contextData", "editStatus"],
  data() {
    return {
      itemdata: "",
      label: "",
      // rules: utils.generateFormRule(this.jsonContext),
      formLabelAlign: {
        value: ""
      }
    };
  },
  computed: {
    visible() {
      if (this.fatherContent.itemType) {
        return this.fatherContent.itemType.displayReference.visible;
      }
      return this.fatherContent.displayReference.visible;
    },
    hostKey(){
      return this.host + "." + this.fatherContent.key
    },
  },
  watch: {
    formLabelAlign: {
      handler(val) {
        this.$emit("fatherCall", {
          key: this.fatherContent.key,
          value: val.value
        });
      },
      deep: true
    },
    disabled: {
      handler(val) {
        if (!val) {
          this.callNative();
        }
      }
    }
  },
  methods: {
    callNative() {
      callApp(
        "getGPS",
        {
          type: "dataSource.gps",
          data: {}
        },
        "cbGetGPS"
      ).then(data => {
        if (data.gps) {
          this.$nextTick(() => {
            this.itemdata = this.formatAddress(data.gps);
          });

          this.formLabelAlign.value = data.gps;
        }
      });
    },
    formatAddress(gps) {
      if (gps) {
        var addressList =
          (gps && [gps.city || "", gps.province || "", gps.country || ""]) ||
          [];
        var country = (gps && gps.country) || "";
        if (country === "中国" || country === "中國") {
          addressList = addressList.reverse();
        }
        return addressList.join(" ");
      }
      return "";
    },
    localized(key) {
      return language.localize(
        this.$store.state,
        this.fatherContent.key,
        key,
        this.fatherContent.displayReference[key]
      );
    }
  },
  created() {},
  mounted() {

    this.label =
            this.fatherContent &&
            this.fatherContent.displayReference &&
            this.fatherContent.displayReference.label;

    if (this.datamodel && (this.datamodel.country || this.datamodel.province || this.datamodel.city)) {
      // 1 已经有地址
      this.itemdata = this.formatAddress(this.datamodel);
      this.$forceUpdate();
      this.formLabelAlign.value = this.datamodel;
    } else {
      // 1 地址为空，call native
      this.callNative();
    }
  }
};
</script>
<style lang='scss' scoped>

.rt-input {
  &.el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa !important;
    border-color: transparent !important;
    color: black !important;
    cursor: not-allowed !important;
  }

  input:disabled {
    opacity: 1 !important;
  }
}
</style>
